'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp2;

var _reactRouter = require('react-router');

var _reactRouterBootstrap = require('react-router-bootstrap');

var _reactBootstrap = require('react-bootstrap');

var _RightPanel = require('./RightPanel');

var _RightPanel2 = _interopRequireDefault(_RightPanel);

var _components2 = require('components');

require('./Header.less');

require('./countryPhone.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    HeaderView: {
        displayName: 'HeaderView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Header/default/HeaderView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var HeaderView = _wrapComponent('HeaderView')((_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(HeaderView, _Component);

    function HeaderView() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, HeaderView);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = HeaderView.__proto__ || (0, _getPrototypeOf2.default)(HeaderView)).call.apply(_ref, [this].concat(args))), _this), _this.handleClickOpen = function () {
            _this.props.handleClick();
            document.documentElement.classList.add('scroll_hide');
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(HeaderView, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                logo = _props.logo,
                operationMode = _props.operationMode,
                operationModeShow = _props.operationModeShow,
                pages = _props.pages,
                phone = _props.phone,
                phoneShow = _props.phoneShow,
                title = _props.title,
                user = _props.user,
                lang = _props.lang;


            return _react3.default.createElement(
                'header',
                { className: 'Header__view navbar-fixed-top top-bar animate-dropdown' },
                _react3.default.createElement(
                    'div',
                    { className: 'container' },
                    _react3.default.createElement(
                        'div',
                        { className: 'row no-margin add_container' },
                        _react3.default.createElement(
                            'div',
                            { className: 'col-xs-9 col-sm-8 col-md-9 col-lg-9 no-margin container_header_left_flex' },
                            _react3.default.createElement(
                                'div',
                                { className: 'hamburger-icon' },
                                _react3.default.createElement(
                                    'div',
                                    { className: 'hamburger-icon__bars' },
                                    _react3.default.createElement('i', { className: 'fa fa-bars icon_hamburger', onClick: this.handleClickOpen })
                                ),
                                _react3.default.createElement(_components2.Notification, { className: 'hidden-lg auth_holder hamburger-icon__warning' })
                            ),
                            _react3.default.createElement(_components2.Logo, { logo: logo, imgClassName: 'header_logo' }),
                            _react3.default.createElement(
                                'div',
                                { className: 'title_holder' },
                                _react3.default.createElement(
                                    'div',
                                    { className: 'title_flex' },
                                    _react3.default.createElement(
                                        'h2',
                                        { className: 'default_header hidden-xs default-header-sm' },
                                        title
                                    ),
                                    _react3.default.createElement(
                                        _reactRouter.Link,
                                        { className: 'default_header visible-xs default-header-xs', to: '/' },
                                        title
                                    ),
                                    phoneShow ? _react3.default.createElement(
                                        'div',
                                        { className: 'default_header_phone' },
                                        phone
                                    ) : null
                                ),
                                operationModeShow ? _react3.default.createElement(
                                    'div',
                                    { className: 'operation_mode' },
                                    operationMode
                                ) : null
                            ),
                            _react3.default.createElement(
                                'ul',
                                { className: 'default_header_static hidden-xs hidden-sm hidden-md' },
                                pages.map(function (page, index) {
                                    return index < 2 ? _react3.default.createElement(
                                        'li',
                                        { key: index },
                                        _react3.default.createElement(
                                            _reactRouter.Link,
                                            { to: '/page/' + page.url },
                                            page.title
                                        )
                                    ) : null;
                                }),
                                pages.length > 2 ? _react3.default.createElement(
                                    'li',
                                    null,
                                    _react3.default.createElement(
                                        'div',
                                        { className: 'dropdown-holder hidden-xs hidden-sm hidden-md' },
                                        _react3.default.createElement(
                                            _reactBootstrap.DropdownButton,
                                            {
                                                bsStyle: 'link',
                                                id: 'dropdown-basic',
                                                noCaret: true,
                                                title: lang['store.header.menu_more']
                                            },
                                            pages.map(function (page, i) {
                                                return i >= 2 ? _react3.default.createElement(
                                                    _reactRouterBootstrap.LinkContainer,
                                                    {
                                                        key: i,
                                                        to: '/page/' + page.url
                                                    },
                                                    _react3.default.createElement(
                                                        _reactBootstrap.MenuItem,
                                                        { eventKey: i + 1 },
                                                        page.title
                                                    )
                                                ) : null;
                                            })
                                        )
                                    )
                                ) : null
                            ),
                            _react3.default.createElement(
                                'div',
                                { className: 'header_more dropdown-holder hidden-xs hidden-lg' },
                                _react3.default.createElement(
                                    _reactBootstrap.DropdownButton,
                                    { bsStyle: 'link', title: lang['store.header.menu'], noCaret: true, id: 'dropdown-basic' },
                                    pages.map(function (page, i) {
                                        return _react3.default.createElement(
                                            _reactRouterBootstrap.LinkContainer,
                                            { key: i, to: '/page/' + page.url },
                                            _react3.default.createElement(
                                                _reactBootstrap.MenuItem,
                                                { eventKey: i + 1 },
                                                page.title
                                            )
                                        );
                                    })
                                )
                            )
                        ),
                        _react3.default.createElement(
                            'div',
                            { className: 'col-xs-3 col-sm-4 col-md-3 col-lg-3 no-margin container_header_right_flex' },
                            _react3.default.createElement(_RightPanel2.default, { user: user, lang: lang })
                        )
                    )
                )
            );
        }
    }]);
    return HeaderView;
}(_react2.Component), _class.propTypes = {
    handleClick: _react2.PropTypes.func.isRequired,
    logo: _react2.PropTypes.string.isRequired,
    operationMode: _react2.PropTypes.any,
    operationModeShow: _react2.PropTypes.any,
    pages: _react2.PropTypes.array,
    phone: _react2.PropTypes.string,
    phoneShow: _react2.PropTypes.any,
    title: _react2.PropTypes.string.isRequired,
    user: _react2.PropTypes.object,
    lang: _react2.PropTypes.object
}, _temp2));

exports.default = HeaderView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/default/HeaderView.jsx
// module id = 1677
// module chunks = 0